import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

/**
 * Componente reutilizable para estados de carga
 * 
 * Proporciona una UI consistente cuando se está obteniendo datos, con:
 * - Spinner animado
 * - Mensaje de carga personalizable
 * - Descripción adicional
 * 
 * @example
 * // Loading state simple
 * <app-loading-state
 *   message="Cargando comunidades...">
 * </app-loading-state>
 * 
 * @example
 * // Con descripción
 * <app-loading-state
 *   message="Procesando datos"
 *   description="Por favor espera mientras se obtienen los resultados">
 * </app-loading-state>
 */
@Component({
  selector: 'app-loading-state',
  templateUrl: './loading-state.component.html',
  styleUrl: './loading-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatIconModule, MatProgressSpinnerModule]
})
export class LoadingStateComponent {
  /**
   * Mensaje de carga a mostrar
   * @default 'Cargando datos...'
   */
  @Input() message: string = 'Cargando datos...';

  /**
   * Descripción adicional (opcional)
   */
  @Input() description?: string;

  /**
   * Diámetro del spinner en píxeles
   * @default 50
   */
  @Input() spinnerDiameter: number = 50;
}
